/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {PixiesVsPiratesServerDataParser} from "../PixiesVsPiratesServerDataParser";
import {IPixiesVsPiratesInitData} from "../serverdata/IPixiesVsPiratesServerData";
import {IPixiesVsPiratesParsedServerData} from "./IPixiesVsPiratesParsedServerData";

export class PixiesVsPiratesParsedInitData extends ParsedInitData implements IPixiesVsPiratesParsedServerData {

    protected _gameAreaSize:number[];
    private readonly _playerFSSelection:number;
    private readonly _freespinRound:number;
    private readonly _pixieFSCount:number;
    private readonly _pirateFSCount:number;
    private readonly _wildMultipliers:number[];
    private readonly _numberOfSpinsPerFSRound:number;
    public readonly accumulatedRoundWin:number;

    public get gameAreaSize():number[] {
        return this._gameAreaSize;
    }

    public get playerFSSelection():number {
        return this._playerFSSelection;
    }

    public get freespinRound():number {
        return this._freespinRound;
    }

    public get pixieFSCount():number {
        return this._pixieFSCount;
    }

    public get pirateFSCount():number {
        return this._pirateFSCount;
    }

    public get wildMultipliers():number[] {
        return this._wildMultipliers;
    }

    public get numberOfSpinsPerFSRound():number {
        return this._numberOfSpinsPerFSRound;
    }

    constructor(rawData:IPixiesVsPiratesInitData, dataParser:PixiesVsPiratesServerDataParser) {
        super(rawData, dataParser);

        this._gameAreaSize = dataParser.parseGameAreaSize(rawData);
        this._playerFSSelection = dataParser.parsePlayerFSSelection(rawData);
        this._freespinRound = dataParser.parseFreespinRound(rawData);
        this._pixieFSCount = dataParser.parsePixieFSCount(rawData);
        this._pirateFSCount = dataParser.parsePirateFSCount(rawData);
        this._wildMultipliers = dataParser.parseWildMultipliers(rawData);
        this._numberOfSpinsPerFSRound = dataParser.parseNumberOfSpinsPerFSRound(rawData);
        this.accumulatedRoundWin = Number(rawData.accumulatedRoundWin);
    }
}